import React, { Component } from "react";
import $ from 'jquery';
import { isSafari as safari, isChrome as chrome, isEdge as edge, isMobileOnly as mobileOnly, isTablet as tablet, osName as osname, browserName as browName} from "react-device-detect";
import Const from "../../constants/Constants";
import InstructorTutorial from "./InstructorTutorial";
import SessionDataStore from "../../streaming/SessionDataStoreController";
import secondaryWindow from "../../utils/secondaryWindow";
import Util from "../../streaming/Util";
import TimerEnterprise from "./TimerEnterprise";
import axios from "axios";

class HostControls extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			isEndedSession: false,
			sessionTime: '00 : 00 : 00',
			cameraArray: [],
			openAudioControls: false,
			openVideoControls: false,
			openTestingMic: false,
			openMoreControls: false,
			isPlayedSpeaker: 0,
			microphoneTestPart: 'start',
			isPlayedAudio: 0,
			speakerTestPart: 'start',
			isElectron: window['electron'],
			startRecording: false,
			startRecordingTemp: false,
			startMusic: false,
			startMusicTemp: false,
			showOtherMembers: false,
			showOtherMembersTemp: false,
			switchInstructorMember: false,
			switchInstructorMemberTemp: false,
			disableSound: false,
			disableSoundTemp: false,
			turnOffRoom: false,
			turnOffRoomTemp: false,
			calculateAssesment: false,
			calculateAssesmentTemp: false,
			customResolution: '',
			customResolutionTemp: '',
			currentUserData: JSON.parse(localStorage.getItem('userData')),
			//tutorialMessNum: 1,
			currentStationId: "",
			sep: '~@$',
			renderSecondaryWindowButton:false,
			redTimer: false,
			tenSecRule: false,
			fmVolume: JSON.parse(localStorage.getItem('userData')).default.instructorFeedFmVolumeD2c ? JSON.parse(localStorage.getItem('userData')).default.instructorFeedFmVolumeD2c : 25,
			hideFmControls: false,
			hideFmControls: false,
			audioInstruction: '',
			boxingPosition: '',
			bagPosition: window['bagPosition'],
			bagPositionTemp: window['bagPosition'],
			boxingCirclePosition: window['boxingCirclePosition'],
			boxingCirclePositionTemp: window['boxingCirclePosition']
		}
		
		this.xInterval = null;
		this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
		this.playerFunctions = window['playerFunctions'];
		this.sessionDataStore = SessionDataStore.getInstance();
		
		this.secondaryWindowCall = new secondaryWindow();
		
		window['checkForFm'] = this.checkForFm;
		window['handleUpdateRemote'] = this.handleUpdateRemote;
		window['changeHostVolumeFm'] = this.changeHostVolumeFm;
		window['showHideVolume'] = this.showHideVolume;
	}
 
	componentDidMount(){
		if ( localStorage.getItem('userData') ) 
			{
				var mainData = JSON.parse(localStorage.getItem('userData'));
				let currDate = new Date(mainData.sessionData.scheduleDate);
				if(mainData.isMarketplaceChannel == 1 && this.state.isElectron){
					this.setState({renderSecondaryWindowButton:true});
					//this.openMultiWindows();
				}
				currDate.setMinutes(currDate.getMinutes() + mainData.sessionData.duration);
				//this.countdownTimer(currDate);
					
				
				
				var sessionData = JSON.parse(localStorage.getItem('userData')).sessionData;
			
				if ( sessionData.StartRecordSession === 1 )
					{
						this.setState({startRecording: true});
					}
					
				if ( sessionData.StartMusicSession === 1 )
					{
						this.setState({startMusic: true});
					}
					
				if ( sessionData.showOtherParticipants === 1 )
					{
						this.setState({showOtherMembers: true});
					}
								
				if ( sessionData.switchHostParticipant === 1 )
					{
						this.setState({switchInstructorMember: true});
					}
					
				if ( sessionData.disableNotificationSound === 1 && !this.props.state.multi_window) 
					{
						this.setState({disableSound: true});
					}
					
				if ( mainData.userType == Const.USER_TYPE.HOST && localStorage.getItem("hostSettings") !== null )
					{
						let settings = JSON.parse(localStorage.getItem("hostSettings"));
						if ( settings.sessionId == sessionData.id && settings.turnoffRoomSetup != undefined && settings.turnoffRoomSetup === 1 )
							{
								this.setState({turnOffRoom: true});
							}
					}
					
				if ( sessionData.calculateAssesment === 1 )
					{
						this.setState({calculateAssesment: true});
					}
				
				if ( this.props.state.multi_window && 1 == 2 )
					{
						this.setState({customResolution: '4kp'},()=>{
							let mainthis = this;
							setTimeout(function(){
								if ( window['setUserProfile'] )
									{
										window['setUserProfile'](mainthis.state.customResolution);
									}
							},1000);
							
							
						});
						localStorage.setItem("video-resolution", '4kp');
					}
				else 
					{
						this.setState({customResolution: localStorage.getItem("video-resolution")});
					}					
					
			}
			
		document.addEventListener('mousedown', this.handleClickOutside);
	}
	
	componentWillUnmount(){
	  clearInterval(this.xInterval);
	  document.removeEventListener('mousedown', this.handleClickOutside);
	}
	
	handleClickOutside = (event) => {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
           this.setState({openAudioControls: false, openVideoControls: false, openTestingMic: false, openMoreControls: false});
        }
    }
	
	showHideVolume=(mod)=>{
		this.setState({hideFmControls: mod});
	}
	
	checkForFm=()=>{
		if ( this.state.currentStationId != "" ) 
			{ 
				window['sendMessageToChannel']("feedFm"+this.state.sep+"play"+this.state.sep+this.state.currentStationId);
			}	
	}
	
	handleUpdateRemote=(rec,music)=>{
		this.setState({
			startRecording: rec,
			startMusic: music,
		});
	}
	
	countdownTimer=(sessionDate)=>{
		if ( !window['isTutorialStarted'] )
			{
				var deadline = 0;
				var sessionData = JSON.parse(localStorage.getItem('userData')).sessionData;
				var fullTimeMinutes = sessionData.duration;
				var sessionStations = sessionData.sessionStations;
				var sessionTimes = [];
				for ( let i = 0; i < sessionStations.length; i++ ) { sessionTimes.push(sessionStations[i].time); }
				
				let tutorialData = JSON.parse(localStorage.getItem('tutorialData'));
				if ( tutorialData ) 
					{
						if ( this.state.currentUserData.sessionData.id == tutorialData.sessionId )
							{
								let currentUserData = JSON.parse(localStorage.getItem('userData'));
								let seconds = currentUserData['default']['defaultSessionDuration'] * 60;
								let currDate = new Date();
								currDate.setSeconds(currDate.getSeconds() + seconds);
								deadline = new Date(currDate).getTime();
							}
						else 
							{
								deadline = new Date(sessionDate).getTime();
							}							
					}
				else 
					{
						deadline = new Date(sessionDate).getTime();
					}
					
				var now,
				timeRemaining,
				hours,
				minutes,
				seconds;
				  
				var mainthis = this;
				this.xInterval = setInterval(function() {
					now = new Date().getTime(); 
					timeRemaining = deadline - now;
					
					let sessionStartTime = new Date(sessionData.scheduleDate).getTime();
					
					if ( mainthis.props.state.sessionStartedByHost === false )
						{
							let timeToStart = sessionStartTime - now;
							timeToStart = timeToStart / 1000;
							if ( timeToStart > 0 && timeToStart < 11  )
								{
									mainthis.setState({tenSecRule: true});
								}								
						}
					else 
						{
							mainthis.setState({tenSecRule: false});
						}						

					if (timeRemaining < 0) 
						{ 
							clearInterval(mainthis.xInterval);
							mainthis.setState({
								sessionTime: 'Class Ended', 
								isEndedSession: true,
								redTimer: false,
								});
						} 
					else 
						{
							let allMinutes = Math.floor(timeRemaining / 60000);
							seconds = ("0" + (Math.floor((timeRemaining / 1000) % 60) % 60)).slice(-2);
							minutes = ("0" + Math.floor((timeRemaining / 60000) % 60)).slice(-2);
							hours = Math.floor((timeRemaining / 3600000));
							
							if(hours >= 100) {
							  hours = ("0" + hours).slice(-3);
							} else {
							  hours = ("0" + hours).slice(-2);
							}
							
							if ( mainthis.props.state.multi_window === false )
								{
									let time = hours + ':' + minutes + ':' + seconds;
									mainthis.setState({sessionTime: time});
								}
							else 
								{
									if ( parseInt(allMinutes) < 10 )
										{
											allMinutes = "0" + allMinutes;
										}
									let time = allMinutes + ':' + seconds;
									mainthis.setState({sessionTime: time});
									
									if ( parseInt(allMinutes) < 1 && parseInt(seconds) < 11 )
										{
											mainthis.setState({
												redTimer: true,	
											});
										}
								}								

							
							var totalMinutesLeft = (parseInt(hours) * 60) + parseInt(minutes);
							var currentMinute = fullTimeMinutes - totalMinutesLeft;
							
							if ( sessionTimes.indexOf(currentMinute) > -1 )
								{
									var index = sessionTimes.indexOf(currentMinute);
									var stationMain = sessionStations[index];
									if ( parseInt(stationMain.stationId) > 0 )
										{
											if ( mainthis.state.currentStationId == stationMain.stationId ) { return false; }
											mainthis.playPlayer(stationMain.stationId, stationMain.stationName);
										}
									else
										{
											if ( mainthis.state.currentStationId == "" ) { return false; }
											
											mainthis.stopPlayer();
										}
								}
				
						}
				}, 1000); 
			}
		
	}
	
	preventDef=(e)=>{
		e.preventDefault();
		e.stopPropagation();
	}
	
	playPlayer=(id, name)=>{
		this.playerFunctions.stopPlayer();
		this.playerFunctions.playPlayer(id, name);
		this.setState({currentStationId: id});
		window['sendMessageToChannel']("feedFm"+this.state.sep+"play"+this.state.sep+id);
		window['showVolume'](true);
		window['currentFmStation'] = id;
		window['currentFmName'] = name;
	}

	stopPlayer=()=>{
		this.playerFunctions.stopPlayer();
		this.setState({currentStationId: ""});
		window['sendMessageToChannel']("feedFm"+this.state.sep+"stop");
		window['showVolume'](false);
		window['currentFmStation'] = "";
		window['currentFmName'] = "";
	}
	
	openCloseAudio=()=>{
		var openAudioControlsVar = this.state.openAudioControls;
		openAudioControlsVar = !openAudioControlsVar;
		this.setState({openAudioControls: openAudioControlsVar, openVideoControls: false, openTestingMic: false, openMoreControls: false});
	}
	
	openCloseVideo=()=>{
		var openVideoControlsVar = this.state.openVideoControls;
		openVideoControlsVar = !openVideoControlsVar;
		this.setState({openVideoControls: openVideoControlsVar, openAudioControls: false, openTestingMic: false, openMoreControls: false});
	}
	
	openCloseMicTesting=()=>{
		var openTestingMicVar = this.state.openTestingMic;
		openTestingMicVar = !openTestingMicVar;
		this.setState({openTestingMic: openTestingMicVar});
		
		if ( !openTestingMicVar && !window['electron'] && this.state.isPlayedAudio === 1 )
			{
				this.startPlayingMicrophone();
			}
			
		if ( !openTestingMicVar && window['electron'] && this.state.microphoneTestPart == 'playing'  )
			{
				this.stopPlayingSpeaker();
			}
		
		if ( !openTestingMicVar && window['electron'] && this.state.isPlayedSpeaker === 1 )
			{
				this.stopPlayingSpeaker();
			}
	}
	
	startPlayingMicrophone = () => {
	 if ( this.state.isPlayedSpeaker === 1 || !window['main_mic_id'] ) { return false; } 
	 
	 if ( !window['electron'] )
		  {
			  if ( !this.audioTest ) 
				{ 
					this.audioTest = document.createElement('audio'); 
				}
				if ( this.state.microphoneTestPart === 'start' )
					{
						navigator.mediaDevices.getUserMedia({ audio: { deviceId: { exact: window['main_mic_id'].toString() } } }).then((stream) =>{
							if ("srcObject" in this.audioTest) { this.audioTest.srcObject = stream; } 
							else { this.audioTest.src = window.URL .createObjectURL(stream); } 
							var mainthis = this;
							this.audioTest.onloadedmetadata = function (ev) { this.play(); $('.mic_control .muted_audio').removeClass('d-none'); };
							
							var audioContent = new AudioContext();
							var audioStream = audioContent.createMediaStreamSource(stream);
							var analyser = audioContent.createAnalyser();
							audioStream.connect(analyser);
							analyser.fftSize = 1024;

							var frequencyArray = new Uint8Array(analyser.frequencyBinCount);
							
							var visualizer = $("#playing_svg #visualizer")[0];
							visualizer.setAttribute("viewBox", "0 0 250 90");

							var path;
							for (var i = 0; i < 10; i++) {
							  path = document.createElementNS("http://www.w3.org/2000/svg", "path");
							  path.setAttribute("stroke-width", "10");
							  path.setAttribute("stroke", "white");
							  path.setAttribute("stroke-linecap", "round");
							  path.setAttribute("stroke-linejoin", "round");
							  visualizer.appendChild(path);
							}
							
							var paths = $("#playing_svg path");
							var doDraw = function() {
							  requestAnimationFrame(doDraw);
							  analyser.getByteFrequencyData(frequencyArray);
							  var adjustedLength;
							  for (var i = 1; i < 9; i++) {
								  
								adjustedLength = Math.floor((Math.floor(frequencyArray[i*20]) - Math.floor(frequencyArray[i*20]) % 5)/5);
								if ( adjustedLength == 0 ) { adjustedLength = 1; } 
								
								paths[i].setAttribute("d", "M " + (i*25) + ",45 l 0,-" + adjustedLength + " l 0," + (adjustedLength*2));
							  }
							};
							doDraw();
							
							
						});  
						
						this.setState({microphoneTestPart: 'playing_web', isPlayedAudio: 1});
						
						if ( !window['isMutedByMe'] )
							{
								if ( window['muteDuringMicTest'] )
									{
										window['muteDuringMicTest']('mute');
									}
							}
					}
					
				if ( this.state.microphoneTestPart === 'playing_web' )
					{
						this.audioTest.pause();  
						this.setState({microphoneTestPart: 'start', isPlayedAudio: 0});
						
						if ( !window['isMutedByMe'] )
							{
								$('.audio_icon .muted_audio').addClass('d-none');
								if ( window['muteDuringMicTest'] )
									{
										window['muteDuringMicTest']('unmute');
									}
								
							}
					}
		  }
	  else
		  {
			  if ( this.state.microphoneTestPart === 'start' )
				  {
					  var recordingfile = 'testRecording_'+(new Date().getTime())+'.aac';
					  var recPath = (osname === "Mac OS" ? '/tmp/' : './');
					  if ( window['recordingPath'] ) { recPath = window['recordingPath'].replace(/\\/g, '/')+'/'; }
				      var srec = window['globalAgora'].agora.startAudioRecording(recPath+recordingfile, 32000, 2);
					  this.setState({microphoneTestPart: 'recording', isPlayedAudio: 1});
					  if ( !this.mainSpeakerTestStream && window['main_mic_id']  )
						{
							this.mainSpeakerTestStream = window.AgoraElectron.createStream({streamID: new Date().getTime(), audio: true, cameraId: 0, microphoneId: window['main_mic_id'], video: false, screen: false });
						}
					  var mainthis = this;
					  if ( srec == 0 )
						  {
								window['globalAgora'].agora.muteLocalAudioStream(true);
								window['globalAgora'].agora.muteAllRemoteAudioStreams(true);
								$('.audio_icon .muted_audio').removeClass('d-none');
								setTimeout(() => {
									window['globalAgora'].agora.stopAudioRecording();
									setTimeout(() => {
											this.setState({microphoneTestPart: 'playing'}, () => {
												this.audioTest = document.createElement('audio'); 
												var audioTest2 = document.createElement('audio');
												this.audioTest.src = recPath+recordingfile;
												audioTest2.src = recPath+recordingfile;
												
												this.mainSpeakerTestStream.startAudioMixing({filePath: recPath+recordingfile, playTime: 0}, function(error) {
													if (error) {
														// Error handling
														return;
													}
												});
												
												this.audioTest.onloadedmetadata = function (ev)
													{
														mainthis.audioTest.play();
														var audioContent0 = (window.AudioContext || window.webkitAudioContext);
														var audioContent = new audioContent0();
														
														var audioStream = audioContent.createMediaElementSource(mainthis.audioTest);
														var analyser = audioContent.createAnalyser();
														audioStream.connect(analyser);
														analyser.fftSize = 1024;
														
														var frequencyArray = new Uint8Array(analyser.frequencyBinCount);
														var visualizer = $("#playing_svg #visualizer")[0];
														visualizer.setAttribute("viewBox", "0 0 250 90");
														
														var path;
														for (var i = 0; i < 10; i++) {
														  path = document.createElementNS("http://www.w3.org/2000/svg", "path");
														  path.setAttribute("stroke-width", "10");
														  path.setAttribute("stroke", "white");
														  path.setAttribute("stroke-linecap", "round");
														  path.setAttribute("stroke-linejoin", "round");
														  visualizer.appendChild(path);
														}
														
														var paths = $("#playing_svg path");
														
														var doDraw = function() {
														 if ( mainthis.state.isPlayedAudio == 0 ) { return false; }
														
														  requestAnimationFrame(doDraw);
														  analyser.getByteFrequencyData(frequencyArray);
														  var adjustedLength;
														  for (var i = 1; i < 9; i++) {
															  
															adjustedLength = Math.floor((Math.floor(frequencyArray[i*20]) - Math.floor(frequencyArray[i*20]) % 5)/5);
															if ( adjustedLength == 0 ) { adjustedLength = 1; }
															
															paths[i].setAttribute("d", "M " + (i*25) + ",45 l 0,-" + adjustedLength + " l 0," + (adjustedLength*2));
														  }
														};
														doDraw();
													}
													
													setTimeout(() => {
														this.audioTest.pause();
														this.setState({microphoneTestPart: 'start', isPlayedAudio: 0});
														
														if ( !window['isMutedByMe'] )
															{
																$('.audio_icon .muted_audio').addClass('d-none');
																window['muteDuringMicTest']('unmute');
															}
															
														else
															{
																/* mainthis.audioTest.stop();
																window.muteSpeaker(); */
															}
														
														if ( window['fsFile'] ) { try { window['fsFile'].unlink(recPath+recordingfile); } catch (err) { } }
														
														if ( $('#microphone-mute').attr('src') == 'images/voice-commands.png' ) 
															{
																window['globalAgora'].agora.muteLocalAudioStream(false);
															}

														window['globalAgora'].agora.muteAllRemoteAudioStreams(false);													
													}, 5000);
												
											});
									}, 1000);
								}, 5000);	
						  }
				  }
		  }
	}
	
	startPlayingSpeaker = () => {
	  if ( this.state.isPlayedAudio === 1 ) { return false; } 
	  $('.audio_icon .muted_audio').removeClass('d-none');
	  if ( !this.mainSpeakerTestStream && window['main_mic_id']  )
		{
			this.mainSpeakerTestStream = window.AgoraElectron.createStream({streamID: new Date().getTime(), audio: true, cameraId: 0, microphoneId: window['main_mic_id'], video: false, screen: false });
		}
		
		window['globalAgora'].agora.muteLocalAudioStream(true);
		window['globalAgora'].agora.muteAllRemoteAudioStreams(true);
		
		var testPath = window['recordingPath'].replace(/\\/g, '/')+'/test_speaker.mp3';
		
		if ( window['fsFile'] && window['fsFile'].existsSync(window['applicationPath']+'/build/audio/test_speaker.mp3') && !window['fsFile'].existsSync(testPath)  )
			{
				window['fsFile'].copyFileSync(window['applicationPath']+'/build/audio/test_speaker.mp3', testPath);
			}

		var streamUrl = testPath;
		this.mainSpeakerTestStream.startAudioMixing({filePath: streamUrl, playTime: 0}, function(error) {
			if (error) {
				// Error handling
				return;
			}
		});
		
	  this.setState({speakerTestPart: 'playing', isPlayedSpeaker: 1});
	  
	  var mainthis = this;
	  
	  setTimeout(function(){ mainthis.stopPlayingSpeaker(); }, 5000);
	}
	
	stopPlayingSpeaker = () => {
		this.mainSpeakerTestStream.stopAudioMixing();	  
		this.setState({speakerTestPart: 'start', isPlayedSpeaker: 0});
		window['globalAgora'].agora.muteAllRemoteAudioStreams(false);
		
		if ( !window['isMutedByMe'] )
			{
				$('.audio_icon .muted_audio').addClass('d-none');
			}
	}
	
	showChat=()=>{
		if ( !this.props.chatOpen )
			{
				$('#chat_counter').text(0);
				$('#chat_counter').addClass('d-none');
				localStorage.removeItem('unreadMessagesNum');
				localStorage.removeItem('unreadMessagesClassId');
				this.props.updateStateFromChild({rightMenuOpen: true, chatOpen: true, activityListOpen: false});
			}
		else
			{
				this.props.updateStateFromChild({rightMenuOpen: false, chatOpen: false, activityListOpen: false});
			}
	}
	
	openCloseMore=()=>{
		var openMoreControlsVar = this.state.openMoreControls;
		openMoreControlsVar = !openMoreControlsVar;
		this.setState({openMoreControls: openMoreControlsVar, openAudioControls: false, openTestingMic: false, openVideoControls: false});
		this.props.updateStateFromChild({leaveSession: false});
		
		if ( openMoreControlsVar )
			{
				//set temp values
				this.setState({
					startRecordingTemp: this.state.startRecording,
					startMusicTemp: this.state.startMusic,
					showOtherMembersTemp: this.state.showOtherMembers,
					switchInstructorMemberTemp: this.state.switchInstructorMember,
					disableSoundTemp: this.state.disableSound,
					turnOffRoomTemp: this.state.turnOffRoom,
					calculateAssesmentTemp: this.state.calculateAssesment,
					customResolutionTemp: this.state.customResolution,
					bagPositionTemp: this.state.bagPosition,
					boxingCirclePositionTemp: this.state.boxingCirclePosition
				});
			}
	}
	
	saveHostSettings=()=>{
		var mainData = JSON.parse(localStorage.getItem('userData'));
		mainData.sessionData.StartRecordSession = this.state.startRecordingTemp ? 1 : 0;
		mainData.sessionData.StartMusicSession = this.state.startMusicTemp ? 1 : 0;
		mainData.sessionData.showOtherParticipants = this.state.showOtherMembersTemp ? 1 : 0;
		mainData.sessionData.switchHostParticipant = this.state.switchInstructorMemberTemp ? 1 : 0;
		mainData.sessionData.disableNotificationSound = this.state.disableSoundTemp ? 1 : 0;
		mainData.sessionData.calculateAssesment = this.state.calculateAssesmentTemp ? 1 : 0;
		
		localStorage.setItem('userData', JSON.stringify(mainData));
		
		if ( localStorage.getItem("hostSettings") )
			{
				let settings = JSON.parse(localStorage.getItem("hostSettings"));
				settings.turnoffRoomSetup = this.state.turnOffRoomTemp ? 1 : 0;
				localStorage.setItem('hostSettings', JSON.stringify(settings));
			}
			
		localStorage.setItem("video-resolution", this.state.customResolutionTemp);
		
		if ( this.state.showOtherMembers !== this.state.showOtherMembersTemp ) 
			{
				window.showOtherParticipantsStateChanged(mainData.sessionData.showOtherParticipants);
			}
		
		if ( this.state.turnOffRoom !== this.state.turnOffRoomTemp ) 
			{
				window.roomSetupStateChanged(this.state.turnOffRoomTemp);
			}
		
		if ( this.state.calculateAssesment !== this.state.calculateAssesmentTemp ) 
			{
				window.dimensionsChanged(this.state.calculateAssesmentTemp);
			}
		
		if ( this.state.switchInstructorMember !== this.state.switchInstructorMemberTemp ) 
			{
				window.switchHostParticipantStateChanged(mainData.sessionData.switchHostParticipant);
			}
		
		if ( this.state.bagPosition !== this.state.bagPositionTemp ) 
			{
				this.updateSettings({'bagPosition': this.state.bagPositionTemp});
			}
			
		if ( this.state.boxingCirclePosition !== this.state.boxingCirclePositionTemp ) 
			{
				this.updateSettings({'boxingCirclePosition': this.state.boxingCirclePositionTemp});
			}
		
		window.setUserProfile(this.state.customResolutionTemp);
		window.disableSoundStateChanged();
		
		let settings = {
							'startRecordSession' : this.state.startRecordingTemp,
							'startMusicSession' : this.state.startMusicTemp,
							'showOtherParticipants' : this.state.showOtherMembersTemp,
							'customResolutionHigh' : this.state.customResolutionTemp,
							'switchHostParticipant' : this.state.switchInstructorMemberTemp,
							'disableNotificationSound' : this.state.disableSoundTemp,
							'turnoffRoomSetup' : this.state.turnOffRoomTemp,
							'calculateAssessmentDimensions' : this.state.calculateAssesmentTemp
						};
						
		let addObject = {"sessionId": mainData.sessionData.id, "event": "instructorSettings", "eventType": "saveInSession", "userId": mainData.id, "details": JSON.stringify(settings), "timestamp": Util.getCurrentTimestamp()};
		this.sessionDataStore.addSessionData(addObject);
		
		let updateClassSettingsData = {
			'classId' : mainData.sessionData.id,
			'startRecordSession' : this.state.startRecordingTemp ? 1 : 0,
			'startMusicSession' : this.state.startMusicTemp ? 1 : 0,
			'showOtherParticipants' : this.state.showOtherMembersTemp ? 1 : 0,
			'switchHostParticipant' : this.state.switchInstructorMemberTemp ? 1 : 0,
			'customResolutionHigh' : this.state.customResolutionTemp,
			'disableNotificationSound' : this.state.disableSoundTemp ? 1 : 0,
			'turnoffRoomSetup' : this.state.turnOffRoomTemp ? 1 : 0,
			'calculateAssessmentDimensions' : this.state.calculateAssesmentTemp ? 1 : 0,
		}
		
		axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/updateClassSettings", updateClassSettingsData).then(res => {
		console.log('--res--', res);		 
		}).catch(err =>{ console.log('err'); }); 
		
		this.setState({
						startRecording: this.state.startRecordingTemp,
						startMusic: this.state.startMusicTemp,
						showOtherMembers: this.state.showOtherMembersTemp,
						switchInstructorMember: this.state.switchInstructorMemberTemp,
						disableSound: this.state.disableSoundTemp,
						turnOffRoom: this.state.turnOffRoomTemp,
						calculateAssesment: this.state.calculateAssesmentTemp,
						customResolution: this.state.customResolutionTemp,
						openMoreControls: false,
						bagPosition: this.state.bagPositionTemp,
						boxingCirclePosition: this.state.boxingCirclePositionTemp
					}, ()=>{
						let startRecordingNum = 0;
						let showOtherMembersNum = 0;
						if ( this.state.startRecording )
							{
								startRecordingNum = 1;
							}
						if ( this.state.showOtherMembers )
							{
								showOtherMembersNum = 1;
							}	
							
						localStorage.setItem("settingsInSession", JSON.stringify({
							'sessionId' : mainData.sessionData.id,
							'StartRecordSession' : startRecordingNum,
							'StartMusicSession' : this.state.startMusic,
							'showOtherParticipants' : showOtherMembersNum,
							'CustomResolutionHigh' : this.state.customResolution,
							'switchHostParticipant' : this.state.switchInstructorMember,
							'disableNotificationSound' : this.state.disableSound,
							'turnoffRoomSetup' : this.state.turnOffRoom,
							'calculateAssesment' : this.state.calculateAssesment
							})
						  );
						  
						  window['sendSyncToRemote']();
					});
		
		if ( document.getElementById('video_precanvas') && document.querySelector('#host_video canvas') )
			{
				setTimeout(() => {
					var recCanvas = document.getElementById('video_precanvas');
					var agoraC = document.querySelector('#host_video canvas');
					
					recCanvas.width = agoraC.width < 1280 ? 1280 : agoraC.width;
					recCanvas.height = agoraC.width < 1280 ? 720 : agoraC.height;
				}, 2000);
			}
	}
	
	nextTutorial=(mod, ev)=>{
		this.props.nextTutorial(mod); 
	}
	
	backTutorial=(mod, ev)=>{
		this.props.backTutorial(mod);
	}
	
	openMultiWindows=()=>{
		this.secondaryWindowCall.openNewWindows();
		if ( window['resubscribeAll'] )
			{
				window['resubscribeAll'](true);
			}
		if ( window['showD2CmembersOnline'] )
			{
				window['showD2CmembersOnline']();
			}
	}
	
	resumeScript=()=>{
		$('#resumeButtonClick').trigger('click');
	}
	
	pauseScript=()=>{
		$('#pauseButtonClick').trigger('click');
	}
	
	stopScript=()=>{
		$('#stopButtonClick').trigger('click');
	}
	
	startClassFun=()=>{
		window['clickedOnLeave'] = false;
		this.props.startClass();
		var sessionDataStorage = JSON.parse(localStorage.getItem('userData')).sessionData;
		
		if ( this.props.d2cClass && $('#record_text').text() !== 'Stop Recording' ) 
			{
				$('#record_session').trigger('click');
			}
	}
	
	changeHostVolumeFm=(e, mod)=>{
		if (mod == undefined)
			{
				let value = e.target.value;
				this.setState({[e.target.id]: e.target.value}, ()=>{
					window['changeFmVolumeHost'](value);
				});
			}
		else 
			{
				this.setState({fmVolume: mod}, ()=>{
					window['changeFmVolumeHost'](mod);
				});
			}
	}
	
	saveEquipmentInfo = (statement, value)=>{
		axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getBoxingPosition", { 'userId': this.state.currentUserData.id, 'equipmentStatement': statement, 'value': value }).then(res => {
		  
		var setBagPositions = res.data.responseData;
		var boxingPosition = setBagPositions['boxingPosition'] ? setBagPositions['boxingPosition'] : '';
		var boxingCirclePositions = setBagPositions['boxingCirclePosition'] ? setBagPositions['boxingCirclePosition'] : 1;
		var boxingPositionState;
		
		if ( boxingPosition != '' )
			{
				boxingPositionState = boxingPosition == 1 ? 'Right' : boxingPosition == 0 ? 'Left' : '';
			}
		else
			{
				boxingPositionState = '';
			}
			
		this.setState({
			boxingPosition: boxingPositionState,
			boxingCirclePosition: boxingCirclePositions
		},()=>{
			window['updateBoxingCircle'](this.state.boxingCirclePosition);
		});
		window['boxingCirclePosition'] = boxingCirclePositions;
		
		}).catch(err =>{ console.log('err'); });
	}
	
	updateSettings = (newState) => {
		this.setState(newState, () => {
			window['audioType'] = this.state.audioInstruction;
			window['boxingType'] = this.state.boxingPosition;
			window['bagPosition'] = this.state.bagPosition;
			window['changeBoxingPosition'](window['boxingType'], window['bagPosition']);
			var setAudioPar = window['audioType'] == 'longAudio' ? 1 : window['audioType'] == 'shortAudio' ? 2 : 0;
			var setBoxingPar = this.state.boxingCirclePosition;
			var setBoxingPos = window['bagPosition'] == 'rightPosition' ? 1 : 0;
			var equipmentStatement = 'boxingPosition';
			this.saveEquipmentInfo('boxingCirclePosition', this.state.boxingCirclePosition);
			if ( window['updateBagPosition'] ) { window['updateBagPosition'](this.state.currentUserData.id, window['bagPosition']); }
			axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/updateVirtualInstruction", { 'voiceType': setAudioPar, 'boxingType': setBoxingPar, 'boxingPosition': setBoxingPos, 'userId': this.state.currentUserData.id, 'equipmentStatement': equipmentStatement  }).then(res => {
				 
			}).catch(err =>{ console.log('err'); }); 
			
		});
	}
	
	render() {
		return (
			<div ref={this.wrapperRef}>			
				<div className="controls_container transparent">
					{this.props.state.tutorialMessNum == 1 &&
						<InstructorTutorial
						nextTutorial={this.nextTutorial}
						backTutorial={this.backTutorial}
						state={this.state}>
						</InstructorTutorial>
					}
					{!this.props.multiWindow && 
						<TimerEnterprise
						mainthis={this}
						></TimerEnterprise>
					}
					<div className={"control_container menu_hidden_item " + (this.state.openAudioControls ? 'active' : '')} onClick={this.openCloseAudio}>
						<div className="control_icon audio_icon">
							<div className="control_arrow"></div>
							<div className="muted_audio d-none"></div>
						</div>
						<div className="control_title">Audio</div>
						<div className={"control_drop " + ( !this.state.openAudioControls ? "d-none" : "" ) } onClick={this.preventDef}>
							<div className={( this.state.openTestingMic ? "d-none" : "" ) }>
								<div className="drop_container">
									<div className="drop_title">Select a Microphone</div>
									<div id="microphone_options"></div>
									{this.props.state.micArray.length > 0 &&
										<div>
											{this.props.state.micArray.map((opt, i) => 
												<div className="relative_holdD2c" >
													<div className="drop_option" id="chose_mic" data-keyid={opt.indexCam} data-value={opt.deviceId} data-numId={i} >{opt.label}</div>
													{opt.choosenStatus &&
														<div className="drop_checked"></div>
													}
												</div>
											)}
										</div>
									}
								</div>
								<div className="drop_container" id="mic_control">
									<div className="mic_icon">
										<div className="muted_audio d-none"></div>
									</div>
									<div className="test_title_streaming" id="microphone_control">Mute Microphone</div>
								</div>
								{/* this.props.showFmPlayer && !this.state.hideFmControls &&
									<div className="drop_container bordTop" id="music_control">
										<div className="one_feed_control">
											<div className="test_title_streaming">Music</div>
											<div className="range_feed_content">
												<div className="relative_range">
													<input type="range" className="range_fm w100" id="fmVolume" value={this.state.fmVolume} name="volume "min="0" max="100" onChange={this.changeHostVolumeFm} />
												</div>
												<div className="fm_music_icon"></div>
											</div>
										</div>
									</div>
								*/}
								<div className={( !this.state.isElectron ? "d-none" : "" ) }>
									<div className="drop_container">
										<div className="drop_title">Select a Speaker</div>
										<div id="speaker_options"></div>
										{this.props.state.spArray.length > 0 &&
											<div>
												{this.props.state.spArray.map((opt, i) => 
													<div className="relative_holdD2c" >
														<div className="drop_option" id="chose_speak" data-keyid={opt.indexCam} data-value={opt.deviceId} data-numId={i} >{opt.label}</div>
														{opt.choosenStatus &&
															<div className="drop_checked"></div>
														}
													</div>
												)}
											</div>
										}
									</div>
								</div>
								<div className="drop_container no_border" onClick={this.openCloseMicTesting}>
									<div className="test_title_streaming">Test Speaker and Microphone</div>
								</div>
							</div>
							<div className={( !this.state.openTestingMic ? "d-none" : "" ) }>
								<div className="drop_container">
									<div className="drop_title">Microphone
										<div className="drop_close" onClick={this.openCloseMicTesting}></div>
										{ this.state.microphoneTestPart === 'start' &&
											<div className="testing_container" onClick={this.startPlayingMicrophone}>
												<div className="mic_test_icon"></div>
												<div className="test_text">Test</div>
											</div>
										}
										{ (this.state.microphoneTestPart === 'playing_web' || this.state.microphoneTestPart === 'playing') &&
											<div className="testing_container" id="playing_svg" onClick={this.state.microphoneTestPart === 'playing_web' ? this.startPlayingMicrophone : {}}>
												<div className="mic_test_icon"></div>
												<svg className="svg_visualizer" preserveAspectRatio="none" id="visualizer" version="1.1" xmlnsXlink="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink"></svg>
											</div>
										}
										{ this.state.microphoneTestPart === 'recording' &&
											<div className="testing_container">
												<div className="mic_test_icon"></div>
												<div className="test_text">Speak into Mic now...</div>
											</div>
										}
									</div>	
								</div>
								{ this.state.isElectron &&
									<div className="drop_container">
										<div className="drop_title">Speaker</div>
										{ this.state.speakerTestPart === 'start' &&
											<div className="testing_container" onClick={this.startPlayingSpeaker}>
												<div className="mic_test_icon speak_icon"></div>
												<div className="test_text">Test</div>
											</div>
										}
										{ this.state.speakerTestPart === 'playing' &&
											<div className="testing_container">
												<div className="mic_test_icon speak_icon"></div>
												<div className="test_text">Playing...</div>
											</div>
										}
									</div>
								}
							</div>
						</div>
					</div>
					<div className={"control_container menu_hidden_item " + (this.state.openVideoControls ? 'active' : '')}  onClick={this.openCloseVideo}>
						<div className="control_icon video_icon">
							<div className="control_arrow"></div>
						</div>
						<div className="control_title">Video</div>
						<div className={"control_drop " + ( !this.state.openVideoControls ? "d-none" : "" ) } onClick={this.preventDef}>
							<div className="drop_container">
								<div className="drop_title">Select a Camera</div>
								<div id="camera_options"></div>
								{this.props.state.cameraArray.length > 0 &&
									<div>
										{this.props.state.cameraArray.map((opt, i) => 
											<div className="relative_holdD2c" >
												<div className="drop_option" id="chose_camera" data-keyid={opt.indexCam} data-value={opt.deviceId} data-numId={i} >{opt.label}</div>
												{opt.choosenStatus &&
													<div className="drop_checked"></div>
												}
											</div>
										)}
									</div>
								}
							</div>
						</div>
					</div>
					{ /* <div className="control_container menu_hidden_item">
						<div className="control_icon playlist_icon"></div>
						<div className="control_title">Playlist</div>
					</div>  */}
					<div className="control_container menu_hidden_item" onClick={this.showChat}>
						<div className="control_icon chat_icon"></div>
						<div className="control_title">Chat</div>
						<div className="control_counter d-none" id="chat_counter">0</div>
					</div>
					<div className="control_container d-none menu_hidden_item" id="mute_control">
						<div className="control_icon allowedSpeaker" id="speakerIcon" ></div>
						<div className="control_title" id="mute_text">Unmute all</div>
					</div>
					<div className="control_container d-none menu_hidden_item" id="record_session">
						<div className="control_icon record_icon"></div>
						<div className="control_title" id="record_text">Record</div>
					</div>
					<div className="control_container menu_hidden_item" id="my_view">
						<div className="control_icon myview_icon"></div>
						<div className="control_title">My View</div>
					</div>
					{this.state.renderSecondaryWindowButton &&
						<div className="control_container"  onClick={this.openMultiWindows}>
							<div className="control_icon myview_icon"></div>
							<div className="control_title">Show members</div>
						</div>
					}
					<div className={"control_container menu_hidden_item " + (this.state.openMoreControls ? 'active' : '')} onClick={this.openCloseMore} id="instructor_settings" >
						<div className="abs_border"></div>
						<div className="control_icon settings_icon"></div>
						<div className="control_title">Settings</div>
						<div className={"control_drop more_settings_hold " + ( !this.state.openMoreControls ? "d-none" : "" ) } onClick={this.preventDef}>
							<div className="drop_container">
								<div className="drop_title">Host Class Settings</div>
								<div className="drop_option" onClick={()=>{this.setState({startRecordingTemp: !this.state.startRecordingTemp})}}>Start Recording at Start Script
									{ this.state.startRecordingTemp && <div className="drop_checked"></div> }
								</div>
								<div className="drop_option" onClick={()=>{this.setState({startMusicTemp: !this.state.startMusicTemp})}}>Start Music at Start Script
									{ this.state.startMusicTemp && <div className="drop_checked"></div> }
								</div>
								<div className="drop_option" onClick={()=>{this.setState({showOtherMembersTemp: !this.state.showOtherMembersTemp})}}>Show other Members
									{ this.state.showOtherMembersTemp && <div className="drop_checked"></div> }
								</div>
								<div className="drop_option" onClick={()=>{this.setState({switchInstructorMemberTemp: !this.state.switchInstructorMemberTemp})}}>Switch Instructor and Member
									{ this.state.switchInstructorMemberTemp && <div className="drop_checked"></div> }
								</div>
								<div className="drop_option" onClick={()=>{this.setState({disableSoundTemp: !this.state.disableSoundTemp})}}>Disable Notification Sound
									{ this.state.disableSoundTemp && <div className="drop_checked"></div> }
								</div>
								{ this.state.currentUserData.isMarketplaceChannel == 0 &&
									<div className="drop_option" onClick={()=>{this.setState({turnOffRoomTemp: !this.state.turnOffRoomTemp})}}>Turn Off Room Setup
										{ this.state.turnOffRoomTemp && <div className="drop_checked"></div> }
									</div>
								}
								<div className="drop_option" onClick={()=>{this.setState({calculateAssesmentTemp: !this.state.calculateAssesmentTemp})}}>Calculate Assessment Dimensions
									{ this.state.calculateAssesmentTemp && <div className="drop_checked"></div> }
								</div>
							</div>
							<div className="drop_container">
								<div className="drop_title">Custom Resolution</div>
								<div className="drop_option" onClick={()=>{this.setState({customResolutionTemp: '1080p'})}}>High Definition 1080p
									{ this.state.customResolutionTemp === '1080p' && <div className="drop_checked"></div> }
								</div>
								
								<div className="drop_option" onClick={()=>{this.setState({customResolutionTemp: '720p'})}}>High Definition
									{ this.state.customResolutionTemp === '720p' && <div className="drop_checked"></div> }
								</div>
								<div className="drop_option" onClick={()=>{this.setState({customResolutionTemp: '360p'})}}>Standard Definition
									{ this.state.customResolutionTemp === '360p' && <div className="drop_checked"></div> }
								</div>
								<div className="drop_option" onClick={()=>{this.setState({customResolutionTemp: '180p'})}}>Low Definition
									{ this.state.customResolutionTemp === '180p' && <div className="drop_checked"></div> }
								</div>
							</div>
							{window['hasBoxing'] &&
								<>
								<div className="drop_container">
									<div className="drop_title">Boxing Bag Position</div>
									<div className="drop_option" id="bagPosition" onClick={()=>{this.setState({bagPositionTemp: 'leftPosition'})}}>Left
										{ this.state.bagPositionTemp == 'leftPosition' &&
											<div className="drop_checked"></div>
										}
									</div>
									<div className="drop_option" id="bagPosition" onClick={()=>{this.setState({bagPositionTemp: 'rightPosition'})}}>Right
										{ this.state.bagPositionTemp == 'rightPosition' &&
											<div className="drop_checked"></div>
										}
									</div>
								</div>
								<div className="drop_container">
									<div className="drop_title">Boxing Circle Position</div>
									<div className="drop_option" id="boxingCirclePosition" onClick={()=>{this.setState({boxingCirclePositionTemp: 1})}}>90 Degrees
										{ this.state.boxingCirclePositionTemp == 1 &&
											<div className="drop_checked"></div>
										}
									</div>
									<div className="drop_option" id="boxingCirclePosition" onClick={()=>{this.setState({boxingCirclePositionTemp: 0})}}>45 Degrees
										{ this.state.boxingCirclePositionTemp == 0 &&
											<div className="drop_checked"></div>
										}
									</div>
								</div>
								</>
							}
							<div className="drop_container">
								<div className="stream_confirm_btn redo_button" onClick={this.saveHostSettings}>Save</div>
							</div>
						</div>
					</div>
					<div className="control_container menu_hidden_item" onClick={() => this.props.updateStateFromChild({openLeave: true})}>
						<div className="control_icon leave_icon"></div>
						<div className="control_title">End Class</div>
					</div>
				</div>
				{this.props.multiWindow && !this.props.sessionStarted &&
					<div>
						<div className={"startBtnsD2C startClass_newBtn" + (this.props.state.sessionStarted ? "d-none" : "")} id="startClass" onClick={this.startClassFun}>Start Class</div>
					</div>
				}
				{this.props.multiWindow && this.props.sessionStarted && this.props.showStartScriptBtn && this.props.sessionScript && this.props.sessionScript.length > 0 &&
					<div>
						<div className="startBtnsD2C startClass_newBtn" id="startWork" onClick={this.props.startScript}>Start Script</div>
					</div>
				}
				{this.props.multiWindow && this.props.sessionStarted && !this.props.showStartScriptBtn && this.props.sessionScript && this.props.sessionScript.length > 0 &&
					<div className="controls_container transparent controls_script">
						<div className="control_container menu_hidden_item" onClick={this.stopScript}>
							<div className="control_icon playOptionBtn"></div>
							<div className="control_title">Stop</div>
						</div>
						
						{!this.props.pausedStatus ? 
							<div className="control_container menu_hidden_item" onClick={this.pauseScript} >
								<div className="control_icon playOptionBtn pauseBtnHost"></div>
								<div className="control_title">Pause</div>
							</div>
							:
							<div className="control_container menu_hidden_item" onClick={this.resumeScript} >
								<div className="control_icon playOptionBtn playBtnHost"></div>
								<div className="control_title">Resume</div>
							</div>
						}
						{this.state.currentUserData.sessionData.manualAutomaticScript == 0 &&
							<div className="control_container menu_hidden_item">
								<div className="control_icon playOptionBtn skipBtnHost"></div>
								<div className="control_title">Next</div>
							</div>
						}
					</div>
				}
				
			</div>
	)}
}
export default HostControls;
